<div class="wrap center p-b-0-s p-b-1">
    <p *ngIf="topCopy"
       class="h1 p-t-5">{{topCopy | uppercase}}
    </p>
    <h1 *ngIf="name"
        class="h1"
        [ngClass]="topCopy ? 'p-t-5' : 'p-t-9'">{{name}}
    </h1>
</div>

<div class="listing-container__sticky blog-listing-sticky">
    <!-- sticky filters -->
    <div class="pe-none listing-filters__sticky"
         stickyNative
         stickyNativeBodyClass="sticky-listing-container"
         [stickyNativeHeaderOnly]="true"
         [stickyNativeDetectDirection]="true">
        <div class="pe-auto listing-filters__inner">
            <div class="pos-relative flex flex-justify-center center p-b-1 z-3 bg-col-w">
                <ng-container>
                    <div *ngIf="navigationItems?.length"
                         class="m-t-9 m-b-9 w-8 w-12-s flex flex-justify-center flex-justify-start-m flex-justify-start-s m-t-4-s m-b-0-s blog-listing-tags-carousel center p-r-4-s p-b-3-s p-l-4-s">
                        <swiper [scrollbar]="{draggable: true}"
                                [observeParents]="true"
                                [spaceBetween]="4"
                                [slidesPerView]="'auto'"
                                class="p-b-7 p-b-4-s">
                            <ng-container
                                          *ngFor="let option of navigationItems; let first = first; trackBy tagFilter.optionTrackByFn">
                                <ng-container [ngSwitch]="!!typeData.tagRedirect">
                                    <ng-template swiperSlide>
                                        <a [routerLink]="option.url"
                                           *ngSwitchCase="true"
                                           class="button-inline-3 m-t-6 m-b p-r-2 p-l-2 p-a-2"
                                           [ngClass]="[ isSelected(option) ? 'button-inline-4' : 'button-inline-3' ]"
                                           (click)="selectNav(option)">
                                            {{option.name}}
                                        </a>
                                        <ng-container *ngSwitchCase="false">
                                            <button swiperSlide
                                                    class="button-inline-3 m-t-6 m-b p-r-2 p-l-2 p-a-2"
                                                    [ngClass]="[ isSelected(option) ? 'button-inline-4' : 'button-inline-3' ]"
                                                    (click)="selectNav(option)">
                                                {{option.name}}</button>
                                        </ng-container>
                                    </ng-template>
                                </ng-container>
                            </ng-container>
                        </swiper>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="p-b-10 m-t-10">
        <!-- listing -->
        <div class="wrap">
            <!-- empty listing message -->
            <p *ngIf="listing.ready && !listing.models?.length"
               class="s1 center">{{'There are no articles in this category yet.' | translate}}</p>

            <div [grid]="[1, 2, 3, 3][client.sizeId]"
                 [gridColumnGap]="'12px'"
                 [gridRowGap]="client.sizeId > 1 ? '24px' : '32px' ">
                <cms-blog-content-blog-card [model]="model"
                                            class="bg-col-w block"
                                            *ngFor="let model of listing.models; trackBy listing.modelTrackByFn; let isFirst = first; let isLast = last">
                </cms-blog-content-blog-card>
            </div>
        </div>

        <!-- show more button -->
        <div class="center m-t-15"
             *ngIf="listing.hasMore">
            <button [buttonStyle]="'button-1'"
                    [status]="status"
                    (click)="listing.increaseLimit()"
                    [attr.aria-label]="'View more' | translate"
                    type="button">
                {{'View more' | translate}}
            </button>
        </div>
    </div>
</div>